module.exports = __webpack_public_path__ + "media/day/314-5a2c32e3.svg";